// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"9f621e80","453":"30e5f8c1","482":"1135cfff"}[chunkId] + ".chunk.js";
};